import { SET_CUSTOM_PROPERTY_TYPES } from "actions/types";

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CUSTOM_PROPERTY_TYPES:
      return action.payload;
    default:
      return state;
  }
};
